import ScoreForm from './ScoreFormLayout';

import ScoreFormModal from './ScoreFormModal';

export { ScoreFormModal };

export default ScoreForm;
